const getLocalStorage = (key) => {
	let output;
	try {
		const storedValue = localStorage.getItem(key);
		if (storedValue) {
			output = storedValue;
		}
	} catch (error) {
		console.error(error);
	}
	return output;
};

export default getLocalStorage;
